export default __webpack_public_path__ + "static/media/a024-8.b9f275a3.svg";